module.exports = __webpack_public_path__ + "img/6518.c13ed226.jpg";